// extracted by mini-css-extract-plugin
export default {"container":"ao-z","ratingLayout":"bo-z","ratingLabel":"co-z","nonInteractiveRatingLabel":"do-z"};